import React, {useEffect, useState} from 'react';
import {Outlet, useLocation} from "react-router-dom"
import {Button, Layout, PageHeader, Spin, Tag} from 'antd';
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";
import {useAuth} from "../context/Auth";
import SecureLinkModal from "../components/SecureLinkModal";
import Api from "../common/Api";

const {Content, Footer} = Layout;

const DEFAULT_KEY = 'dashboard'

const Dashboard: React.FC = () => {
    const location = useLocation();
    const {user} = useAuth();
    const [groups, setGroups] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState<Array<string>>([])
    const [isModalVisible, setIsModalVisible] = useState(false);

    const getButton = (path: string = 'default') => {
        const PATHS = {
            '/admin': () => <Button key="secure-link" onClick={() => setIsModalVisible(!isModalVisible)} type="primary">
                Generate sign-up link
            </Button>,
            'default': () => null
        }
        if (path in PATHS)
            return PATHS[path as keyof typeof PATHS]()
        return PATHS['default']()
    }


    useEffect(() => {
        const [, path] = location.pathname.split('/');
        if (!path) {
            setSelectedKeys([DEFAULT_KEY])
            return;
        }
        setSelectedKeys([path])
    }, [location, user])

    useEffect(() => {
        (async () => {
            const {data} = await Api.usersManagement.getUser(user?.email!)
            setGroups(data.UserAttributes.find((attribute: { Name: string, Value: any }) => attribute.Name === 'groups').Value)
        })();
    }, [user?.email])

    return (
        <Layout style={{height: '100%'}}>
            <Sidebar defaultKeys={DEFAULT_KEY} selectedKeys={selectedKeys}/>
            <Layout style={{height: "100%"}}>
                <Navbar selectedKeys={selectedKeys}/>
                <PageHeader
                    style={{height: '100%'}}
                    subTitle="Member of"
                    tags={groups.length ? groups.map((group) => <Tag key={group} color="green">{group}</Tag>) :
                        <Spin size="small"/>}
                    extra={[getButton(location.pathname)]}
                >
                    <Content style={{height: '100%'}}>
                        <Outlet/>
                        <SecureLinkModal title="Secure link" setIsModalVisible={setIsModalVisible}
                                         isModalVisible={isModalVisible}/>
                    </Content>
                </PageHeader>
                <Footer style={{textAlign: 'center'}}/>
            </Layout>
        </Layout>
    );
};

export default Dashboard;
